class MenuDrawer {
  constructor() {
    this.drawer = document.querySelector('[data-mobile-drawer]');
    this.openers = document.querySelectorAll('[data-open-menu]');
    this.closers = document.querySelectorAll('[data-close-menu]');
    if (!this.drawer) return;
    this.openers.forEach((button) => button.addEventListener('click', () => this.open()));
    this.closers.forEach((button) => button.addEventListener('click', () => this.close()));
    this.drawer.addEventListener('click', (event) => {
      if (event.target === this.drawer) this.close();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.close();
    });
  }

  open() {
    this.drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('menu-open');
  }

  close() {
    this.drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('menu-open');
  }
}

function bindLocalizationForms() {
  document.querySelectorAll('[data-localization-select]').forEach((select) => {
    select.addEventListener('change', (event) => {
      event.currentTarget.closest('form')?.submit();
    });
  });
}

function bindVariantSelectors() {
  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const masterSelect = form.querySelector('[name="id"]');
    const optionSelects = form.querySelectorAll('[data-option-select]');
    if (!masterSelect || optionSelects.length === 0) return;

    optionSelects.forEach((select) => {
      select.addEventListener('change', () => {
        const selected = Array.from(optionSelects).map((item) => item.value).join(' / ');
        const matched = Array.from(masterSelect.options).find((option) => option.dataset.title === selected);
        if (matched) masterSelect.value = matched.value;
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  new MenuDrawer();
  bindLocalizationForms();
  bindVariantSelectors();
});
